import { Button, Checkbox, DatePicker, Input, Spin } from 'antd'
import { CheckboxChangeEvent } from 'antd/lib/checkbox'
import Axios from 'axios'
import { saveAs } from 'file-saver'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import Modal from '../../component/modal'
import { filter } from '../../utils/filter'
const { RangePicker } = DatePicker

interface IProps {}

interface DownloadProgressIndicatorProps {
    reportId: string
    onFinish: () => void
}

function DownloadProgressIndicator({ reportId, onFinish }: DownloadProgressIndicatorProps) {
    const [progress, setProgress] = useState<string>('0%')

    useEffect(() => {
        const interval = setInterval(() => {
            Axios.get('/data/report-progress', {
                params: {
                    reportId,
                },
            })
                .then(res => {
                    const data = res.data

                    if (data.progressStauts === '1') {
                        onFinish()
                    } else {
                        setProgress(data.downloadProgress)
                    }
                })
                .catch(err => console.error)
                .finally(() => {})
        }, 1000)
        return () => {
            clearInterval(interval)
        }
    }, [reportId, onFinish])

    return (
        <tr>
            <td align="right">Download: </td>
            <td align="left">
                <Button type="primary" disabled>
                    {`Processing (${progress})`}
                </Button>
            </td>
        </tr>
    )
}

const ExtractRawData: React.FC<IProps> = props => {
    const [data, setData] = React.useState([])
    const [state, setState] = React.useState({
        date: [moment(), moment().add({ days: 1 })] as [moment.Moment, moment.Moment],
        platform: '',
        district: [],
        contains: '',
        filterData: [] as any[],
        loading: false,
        noData: false,
        installed: [] as string[],
        paginate: false,
    })
    const [reportId, setReportId] = React.useState('')
    const [isProcessing, setIsProcessing] = React.useState(false)
    const [isFinished, setIsFinished] = React.useState(false)

    const getDevices = () => {
        setState(prev => ({
            ...prev,
            loading: true,
        }))
        const { contains, platform, district, installed } = state
        Axios.get('/devices', {
            params: {
                contains,
                platform,
                district,
                installed,
            },
        })
            .then(res => {
                setData(res.data)
            })
            .catch(err => {
                console.error(err)
            })
            .finally(() => {
                setState(prev => ({
                    ...prev,
                    loading: false,
                }))
            })
    }

    const onSubmit = () => {
        setIsFinished(false)
        setState(prev => ({
            ...prev,
            loading: true,
        }))
        // Axios.get('/data/report', {
        //     params: {
        //         start: state.date[0].format('YYYY-MM-DD HH:mm:ss'),
        //         end: state.date[1].format('YYYY-MM-DD HH:mm:ss'),
        //         platform: state.platform,
        //         district: state.district,
        //         contains: state.contains,
        //         noData: state.noData ? 'true' : 'false',
        //         installed: state.installed,
        //         paginate: state.paginate ? 'true' : 'false',
        //     },
        //     responseType: 'blob',
        // })
        //     .then((res) => {
        //         saveAs(res.data, 'data.xlsx')
        //         setState((prev) => ({
        //             ...prev,
        //         }))
        //     })
        //     .catch((err) => console.error)
        //     .finally(() => {
        //         setState((prev) => ({
        //             ...prev,
        //             loading: false,
        //         }))
        //     })
        Axios.get('/data/report-url', {
            params: {
                start: state.date[0].format('YYYY-MM-DD HH:mm:ss'),
                end: state.date[1].format('YYYY-MM-DD HH:mm:ss'),
                platform: state.platform,
                district: state.district,
                contains: state.contains,
                noData: state.noData ? 'true' : 'false',
                installed: state.installed,
                paginate: state.paginate ? 'true' : 'false',
                totalDeviceNo: getData().length || '0',
            },
        })
            .then(res => {
                setReportId(res.data)
                setIsProcessing(true)
            })
            .catch(err => console.error)
            .finally(() => {
                setState(prev => ({
                    ...prev,
                    loading: false,
                }))
            })
    }

    const onChange = (date: any, dateString: any) => {
        console.log(date)
        setState(prev => ({
            ...prev,
            date,
        }))
    }

    const onPlatformTick = (e: any) => {
        const value = e.target.value
        setState(prev => ({
            ...prev,
            platform: prev.platform !== value ? value : '',
        }))
    }

    const onInputChange = (evt: any) => {
        const value = evt.target.value
        setState(prev => ({ ...prev, district: value.split(',') }))
    }

    const handleInstalledCheck = (e: CheckboxChangeEvent) => {
        const { value } = e.target
        const { installed } = state
        const index = installed.findIndex(e => e === value)
        if (index > -1) {
            installed.splice(index, 1)
        } else {
            installed.push(value)
        }
        setState({
            ...state,
            installed,
        })
    }

    const getData = () => data

    const downloadZipFile = () => {
        setState(prev => ({
            ...prev,
            loading: true,
        }))

        Axios.get('/data/download-report', {
            params: {
                reportId,
            },
            responseType: 'blob',
        })
            .then(res => {
                saveAs(res.data, 'data.zip')
                setState(prev => ({
                    ...prev,
                }))
            })
            .catch(err => console.error)
            .finally(() => {
                setState(prev => ({
                    ...prev,
                    loading: false,
                }))
            })
    }

    return (
        <div>
            <Spin spinning={state.loading}>
                <table cellPadding={5} style={{ width: '700px' }}>
                    <tbody>
                        <tr>
                            <td align="right">Date Range: </td>
                            <td align="left">
                                <RangePicker
                                    onChange={onChange}
                                    value={state.date}
                                    showTime
                                    style={{ width: '100%' }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td align="right">Platform: </td>
                            <td align="left">
                                {' '}
                                <Checkbox checked={state.platform === 'lora'} onChange={onPlatformTick} value="lora">
                                    Lora
                                </Checkbox>
                                <Checkbox
                                    checked={state.platform === 'onenet'}
                                    value="onenet"
                                    onChange={onPlatformTick}
                                >
                                    Onenet
                                </Checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td align="right">District: </td>
                            <td align="left">
                                <Input
                                    placeholder="Select district"
                                    // mode="multiple"
                                    onChange={onInputChange}
                                    style={{ width: '100%' }}
                                    value={state.district}
                                />
                            </td>
                        </tr>

                        <tr>
                            <td align="right">Sensor ID Contains</td>
                            <td>
                                <Input
                                    value={state.contains}
                                    onChange={e => {
                                        const value = e.target.value
                                        setState(prev => ({
                                            ...prev,
                                            contains: value,
                                            filterData: filter(data, value),
                                        }))
                                    }}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td align="right">Installed: </td>
                            <td align="left">
                                <Checkbox
                                    checked={state.installed.findIndex(e => e === 'yes') > -1}
                                    onChange={handleInstalledCheck}
                                    value="yes"
                                >
                                    Yes
                                </Checkbox>
                                <Checkbox
                                    checked={state.installed.findIndex(e => e === 'no') > -1}
                                    onChange={handleInstalledCheck}
                                    value="no"
                                >
                                    No
                                </Checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td align="right">Paginate: </td>
                            <td align="left">
                                {' '}
                                <Checkbox
                                    checked={state.paginate}
                                    onChange={() => {
                                        setState(prev => ({
                                            ...prev,
                                            paginate: true,
                                        }))
                                    }}
                                    value={true}
                                >
                                    Yes
                                </Checkbox>
                                <Checkbox
                                    checked={state.paginate === false}
                                    value={false}
                                    onChange={() => {
                                        setState(prev => ({
                                            ...prev,
                                            paginate: false,
                                        }))
                                    }}
                                >
                                    No
                                </Checkbox>
                            </td>
                        </tr>
                        <tr>
                            <td align="right" style={{ width: '200px' }}>
                                Generate the page when the device no data:{' '}
                            </td>
                            <td align="left">
                                {' '}
                                <Checkbox
                                    checked={state.noData}
                                    onChange={() => {
                                        setState(prev => ({
                                            ...prev,
                                            noData: true,
                                        }))
                                    }}
                                    value={true}
                                >
                                    Yes
                                </Checkbox>
                                <Checkbox
                                    checked={state.noData === false}
                                    value={false}
                                    onChange={() => {
                                        setState(prev => ({
                                            ...prev,
                                            noData: false,
                                        }))
                                    }}
                                >
                                    No
                                </Checkbox>
                            </td>
                        </tr>

                        <tr>
                            <td></td>
                            <td>
                                <Button
                                    type="primary"
                                    style={{ width: '100%' }}
                                    onClick={getDevices}
                                    // disabled={isProcessing || isFinished ? true : false}
                                >
                                    Get Devices
                                </Button>
                            </td>
                        </tr>

                        <tr>
                            <td align="right">Selected Devices: </td>
                            <td align="right">
                                <span style={{ float: 'left' }}>{getData().length || '0'}</span>
                                <Modal devices={getData()} />
                            </td>
                        </tr>
                        <tr>
                            <td></td>
                            <td>
                                <Button
                                    type="primary"
                                    style={{ width: '100%' }}
                                    onClick={onSubmit}
                                    disabled={data.length === 0 ? true : false}
                                    // disabled={data.length === 0 || isProcessing || isFinished ? true : false}
                                >
                                    Export
                                </Button>
                            </td>
                        </tr>

                        {isProcessing ? (
                            <DownloadProgressIndicator
                                reportId={reportId}
                                onFinish={() => {
                                    setIsProcessing(false)
                                    setIsFinished(true)
                                }}
                            />
                        ) : null}

                        {isFinished ? (
                            <tr>
                                <td align="right">Download: </td>
                                <td align="left">
                                    <Button
                                        type="primary"
                                        onClick={() => {
                                            downloadZipFile()
                                        }}
                                    >
                                        Download
                                    </Button>
                                </td>
                            </tr>
                        ) : null}
                    </tbody>
                </table>
            </Spin>
        </div>
    )
}

export default ExtractRawData
